import { LodgingTableFiltersActionTypes, LodgingTableFiltersState, SET_LODGING_TABLE_FILTERS } from "./types";

const defaultState: LodgingTableFiltersState = {
  isLoading: false,
  errorMessage: "",
  contents: {},
  exists: false,
};

export default function lodgingTableFilters(state = defaultState, action: LodgingTableFiltersActionTypes): LodgingTableFiltersState {
  switch (action.type) {
    case SET_LODGING_TABLE_FILTERS:
      return {
        ...state,
        contents: action.contents,
        isLoading: false,
        exists: action.exists,
      };
    default:
      return state;
  }
}
